function cv() {
  window.location.href = "https://narciscristea.com";
  return null;
}

export default cv;
